import Backbone from 'backbone';

export const ValidationsModel = Backbone.Model.extend({
	
	defaults: {
		errors: []
	}

});